module.exports = __webpack_public_path__ + "img/scoreLow.492a8a70.svg";